import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import {
    GenericStoreStatus,
    NonNullableGenericState,
    PROMOTION_STATUS,
    Promotion,
    ReducerUtil,
    SelectorUtil
} from '@us/web/shared/data-access';
import { PromotionsActions } from './promotions.actions';
import { cloneDeep } from 'lodash';

export const PROMOTIONS_FEATURE_KEY = 'promotions';

export interface GenericState<T> {
    data: T;
    status: GenericStoreStatus;
    error: string | null;
    promotionIdNotUse: any[];
}

export type PromotionsState = GenericState<Promotion[]>;

export const initialState: PromotionsState = {
    data: [],
    status: 'pending',
    error: null,
    promotionIdNotUse: []
};

export const promotionsFeature = createFeature({
    name: PROMOTIONS_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(PromotionsActions.loadPromotions, ReducerUtil.setLoading),
        on(PromotionsActions.loadPromotionsSuccess, (state, { promotions }) => {
            promotions = cloneDeep(
                promotions.filter((p: Promotion) => {
                    if (p.is_time) {
                        const time_slot = JSON.parse(p.promotion_time_slots) || [];
                        const time_current = new Date().toLocaleTimeString('en-GB', {
                            hour: 'numeric',
                            minute: 'numeric'
                        });
                        const check_time_slot = time_slot.map((t: any) => {
                            const time = t.split(' - ');
                            return time;
                        });
                        const found = check_time_slot.find(
                            (t: any) =>
                                (t[0] < t[1] && t[0] < time_current && t[1] > time_current) ||
                                (t[0] > t[1] && t[0] < time_current && t[1] < time_current)
                        );
                        if (found && p.status != PROMOTION_STATUS.END) return p;
                        else return false;
                    } else {
                        if (p.status != PROMOTION_STATUS.END) return p;
                        else return false;
                    }
                })
            ).map(p => {
                p.promotion_apply = true;
                return p;
            });
            return ReducerUtil.setSuccess(state, promotions);
        }),
        on(PromotionsActions.loadPromotionsFailure, ReducerUtil.setFailed),
        on(PromotionsActions.updatePromotions, (state, { promotions }) => ReducerUtil.setSuccess(state, promotions)),
        on(PromotionsActions.addPromotionsIdNotUse, (state, { ids }) => ({ ...state, promotionIdNotUse: ids }))
    )
});

export const {
    name,
    reducer,
    selectPromotionsState,
    selectData: selectPromotions,
    selectStatus,
    selectError,
    selectPromotionIdNotUse
} = promotionsFeature;

export const selectLoading = createSelector(selectPromotionsState, SelectorUtil.isLoading);

export const selectPromotionsUserSelect = createSelector(selectPromotions, promotions => promotions);

export const selectPromotionIdNotUseUserSelect = createSelector(
    selectPromotionIdNotUse,
    promotionIdNotUse => promotionIdNotUse
);
